export type JsonLdValue =
    | string
    | number
    | boolean
    | null
    | JsonLdObject
    | JsonLdValue[];

export type JsonLdObject = {
    [key: string]: JsonLdValue;
};

export type JsonLdGraph = {
    '@context': 'https://schema.org';
    '@graph': JsonLdObject[];
};

export const DESKTOP_SITE_ORIGIN = 'https://www.wink.co.kr';
export const DESKTOP_BASE_PATH = '/client/desktop';
export const DESKTOP_SITE_URL = `${DESKTOP_SITE_ORIGIN}${DESKTOP_BASE_PATH}`;

export const ORGANIZATION_ID = `${DESKTOP_SITE_ORIGIN}/#organization`;
export const WEBSITE_ID = `${DESKTOP_SITE_ORIGIN}/#website`;

export const buildDesktopPageUrl = (path = '') => {
    if (!path || path === '/') {
        return DESKTOP_SITE_URL;
    }

    return `${DESKTOP_SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

export const withFragment = (url: string, fragment: string) =>
    `${url.split('#')[0]}#${fragment.replace(/^#/, '')}`;

export const createOrganizationNode = (): JsonLdObject => ({
    '@type': 'Organization',
    '@id': ORGANIZATION_ID,
    name: '윙크학습',
    legalName: '(주) 단비교육',
    url: DESKTOP_SITE_URL,
    logo: 'https://us.wink.co.kr/pc/renewalV3/common/logo-highres.png',
    telephone: '1522-1244',
    email: 'wink@danbiedu.co.kr',
    address: {
        '@type': 'PostalAddress',
        streetAddress: '개포로 640 단비교육',
        addressLocality: '강남구',
        addressRegion: '서울특별시',
        addressCountry: 'KR',
    },
    parentOrganization: {
        '@type': 'Organization',
        name: '단비교육',
    },
    identifier: {
        '@type': 'PropertyValue',
        name: '사업자등록번호',
        value: '629-87-00476',
    },
    sameAs: [
        'https://www.instagram.com/wink_learning',
        'https://blog.naver.com/wink_learning',
    ],
});

export const createWebsiteNode = (): JsonLdObject => ({
    '@type': 'WebSite',
    '@id': WEBSITE_ID,
    name: '가장 많이 선택하는 1위 학습 윙크',
    url: DESKTOP_SITE_URL,
    description: '윙크 공식 홈페이지',
    inLanguage: 'ko-KR',
    publisher: {
        '@id': ORGANIZATION_ID,
    },
});
